import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/aileron/300.css';
import '@fontsource/aileron/400.css';
import '@fontsource/aileron/600.css';
import '@grow/tokens/tokens.css';
import './styles.css';
import { App } from './App.js';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
